<template>
  <el-table
    :data="tableList"
    height="100%"
    stripe
    border
    style="width: 100%"
    size="mini"
    :header-cell-style="{
      'font-weight': 'bold',
      color: '#333',
      'background-color': '#F7F7F7',
    }"
  >
    <el-table-column
      v-for="(v, i) in tableHead"
      :key="i"
      :prop="v.prop"
      :label="v.label"
      align="center"
    ></el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    tableList: {
      type: Array,
      default: () => [],
    },
    tableHead: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style></style>
